var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart"},[_c('div',{attrs:{"id":"ring-chart"}}),_c('div',{staticClass:"num"},[_c('div',[_vm._v("验收率")]),_c('div',[_vm._v(_vm._s(_vm.hiddenScale)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }